module.exports = __webpack_public_path__ + "img/wechat-code-transparency.07a2c278.png";